import axios from 'axios';
import AuthService from './auth-header';

// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ // const API_URL = 'https://ats.sattvahuman.in/api/';

let API_URL = ''
if (process.env.NODE_ENV === "production") {
  API_URL = 'https://ats.sattvahuman.in/api/';
} else {
  API_URL = 'http://192.168.0.30:5000/api/';
}
class reportService {

  async getWorkTracker(v) {
    try {
      //console.log(id)
      const res = await axios.get(API_URL + 'report/tracker/' + v,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      if (err.response && err.response.data) {
        return err.response.data
      }
      return { status: 'ERROR', message: 'Failed to load report.' }
    }
  }

  async getRecTracker(startDate, endDate, emp_id) {
    try {
      const res = await axios.get(`${API_URL}report/recruiter/tracker`, {
        params: {
          startDate,
          endDate,
          emp_id: emp_id || '',
        },
        headers: AuthService.authHeader(),
        validateStatus: status => (status >= 200 && status < 300) || status === 400,
      })
      const body = res.data
      if (body && body.status === 'OK') return body
      // Empty tracker for date/viewer — treat as no rows (Org Performance still works).
      if (res.status === 400 && body && body.status === 'FAILED') {
        return { status: 'OK', data: [], message: body.message || 'No tracker data' }
      }
      return body || { status: 'ERROR', message: 'Failed to load report.' }
    }
    catch (err) {
      if (err.response && err.response.data) {
        return err.response.data
      }
      return { status: 'ERROR', message: 'Failed to load report.' }
    }
  }
  async getSourcerTracker(startDate, endDate) {
    try {
      //console.log(id)
      const res = await axios.get(API_URL + 'report/sourcer/tracker?startDate=' + startDate + '&endDate=' + endDate,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      if (err.response && err.response.data) {
        return err.response.data
      }
      return { status: 'ERROR', message: 'Failed to load report.' }
    }
  }

  async getStatusWiseTracker(startDate, endDate, rec, mgr, loc, client, source, position, date, recSel, mgrSel, clientSel, locSel, sourceSel, empStatusSel, verticalSel, categorySel, extra = {}) {
    try {
      const params = {
        startDate,
        endDate,
        recruiter: rec,
        manager: mgr,
        location: loc,
        client,
        position,
        source,
        date,
        recSelected: recSel || '',
        mgrSelected: mgrSel || '',
        locSelected: locSel || '',
        clientSelected: clientSel || '',
        sourceSelected: sourceSel || '',
        empStatusSelected: empStatusSel || '',
      }
      if (verticalSel) params.vertical = verticalSel
      if (categorySel) params.category = categorySel
      // Prod may ignore unknown flags; local reportController understands groupVertical/groupCategory.
      if (extra.groupVertical) {
        params.groupVertical = true
        params.verticalGroup = true
      }
      if (extra.groupCategory) {
        params.groupCategory = true
        params.categoryGroup = true
      }
      if (extra.groupBy) params.groupBy = extra.groupBy
      if (extra.groupSource) {
        params.groupSource = true
        params.sourceGroup = true
      }
      if (extra.groupDate) {
        params.groupDate = true
        params.dateGroup = true
      }
      if (extra.detailed) {
        params.detailed = true
        params.includeDetailedStatuses = true
      }
      if (Array.isArray(extra.statuses) && extra.statuses.length) {
        params.statuses = extra.statuses.join(',')
      }
      const res = await axios.get(API_URL + 'report/status-wise-tracker', {
        params,
        headers: AuthService.authHeader()
      });
      return res.data
    }
    catch (err) {
      console.log(err.response);
      if (err.response && err.response.data) {
        return err.response.data
      }
      return { status: 'ERROR', message: 'Failed to load report.' }
    }
  }

}
export default new reportService